import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const GymSelectedIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.1328 19.7931C10.1328 22.2784 8.11808 24.2931 5.63281 24.2931C3.14755 24.2931 1.13281 22.2784 1.13281 19.7931C1.13281 17.3077 3.14755 15.293 5.63281 15.293C8.11808 15.293 10.1328 17.3077 10.1328 19.7931Z"
      stroke="#5AF2A6"
      strokeWidth="2"
    />
    <rect opacity="0.5" x="5.16797" y="1.20703" width="1" height="14.174" rx="0.5" stroke="#5AF2A6" />
    <path
      d="M24.2031 19.7931C24.2031 22.2784 22.1884 24.2931 19.7031 24.2931C17.2179 24.2931 15.2031 22.2784 15.2031 19.7931C15.2031 17.3077 17.2179 15.293 19.7031 15.293C22.1884 15.293 24.2031 17.3077 24.2031 19.7931Z"
      stroke="#5AF2A6"
      strokeWidth="2"
    />
    <rect opacity="0.5" x="19.2383" y="1.20703" width="1" height="14.174" rx="0.5" stroke="#5AF2A6" />
  </svg>
)

export const GymIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.1328 19.7931C10.1328 22.2784 8.11808 24.2931 5.63281 24.2931C3.14755 24.2931 1.13281 22.2784 1.13281 19.7931C1.13281 17.3077 3.14755 15.293 5.63281 15.293C8.11808 15.293 10.1328 17.3077 10.1328 19.7931Z"
      stroke="#959693"
      strokeWidth="2"
    />
    <rect opacity="0.5" x="5.16797" y="1.20703" width="1" height="14.174" rx="0.5" stroke="#959693" />
    <path
      d="M24.2031 19.7931C24.2031 22.2784 22.1884 24.2931 19.7031 24.2931C17.2179 24.2931 15.2031 22.2784 15.2031 19.7931C15.2031 17.3077 17.2179 15.293 19.7031 15.293C22.1884 15.293 24.2031 17.3077 24.2031 19.7931Z"
      stroke="#959693"
      strokeWidth="2"
    />
    <rect opacity="0.5" x="19.2383" y="1.20703" width="1" height="14.174" rx="0.5" stroke="#959693" />
  </svg>
)
